import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, OAuthProvider, signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyD41WE04ZjmymBzAudLExcyXoaHiLYpk38",
  authDomain: "softnoesis-7e28b.firebaseapp.com",
  databaseURL: "https://softnoesis-7e28b.firebaseio.com",
  projectId: "softnoesis-7e28b",
  storageBucket: "softnoesis-7e28b.appspot.com",
  messagingSenderId: "244596601598",
  appId: "1:244596601598:web:a00ff2158df3d907f5abaf",
  measurementId: "G-HPZ5S15KKT"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
const appleProvider = new OAuthProvider("apple.com");

auth.useDeviceLanguage();

export { app, auth, database, storage, googleProvider, facebookProvider, appleProvider, RecaptchaVerifier, analytics, logEvent };
